module.exports = __webpack_public_path__ + "static/media/piechart-placeholder-graph.6e6cf767.png";